// eslint-disable-next-line max-len
// export const isMailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isMinSixCharsRegex: RegExp =
  /^\S{6,}$/;
export const isMailRegex: RegExp = /^[\w-.]+@?([\w-]+\.)+[\w-]{2,4}$/;
export const isNameRegex: RegExp = /^\S{6,}$/;

export const isNotEmpty: RegExp = /^\S{1,}$/;
